import React from 'react';
import AnimateIn from './AnimateIn';

const Home = () => (
  <section
    id="home"
    className="hero-brand relative isolate flex min-h-[760px] overflow-hidden bg-[#f4eadc] md:min-h-[820px]"
  >
    <img
      src={`${process.env.PUBLIC_URL}/hero-community.png`}
      alt="A welcoming neighbourhood path at golden hour"
      className="absolute inset-0 -z-20 h-full w-full object-cover object-[61%_center]"
    />
    <div className="absolute inset-0 -z-10 bg-[linear-gradient(90deg,rgba(255,250,242,.94)_0%,rgba(255,250,242,.75)_34%,rgba(255,250,242,.12)_68%,rgba(255,250,242,.05)_100%)]" />

    <div className="mx-auto flex w-full max-w-[90rem] items-center px-6 pb-20 pt-36 md:px-12 md:pt-40 lg:px-16">
      <div className="w-full max-w-[710px]">
        <AnimateIn immediate variant="fade-up">
          <h1 className="text-[3.45rem] font-semibold leading-[0.95] tracking-[-0.06em] text-ink sm:text-[4.75rem] lg:text-[5.7rem]">
            Our products.<br />One belief:
            <span className="mt-2 block bg-[linear-gradient(90deg,#8457e7_0%,#fc3173_62%,#e8366f_100%)] bg-clip-text font-serif font-medium leading-[0.93] tracking-[-0.015em] text-transparent">
              useful technology<br />should feel human.
            </span>
          </h1>
        </AnimateIn>
        <AnimateIn immediate variant="fade-up" delay={120}>
          <p className="mt-8 max-w-[540px] text-base leading-7 text-ink/75 md:text-lg md:leading-8">
            At Lokyis Ltd we build practical, thoughtful products that make everyday life a little easier, kinder and more connected.
          </p>
        </AnimateIn>
        <AnimateIn immediate variant="fade-up" delay={220}>
          <a href="#products" className="btn-navy mt-8">Explore our work <span aria-hidden="true">→</span></a>
        </AnimateIn>
      </div>
    </div>
  </section>
);

export default Home;
